import React, { useContext, useEffect } from 'react';
import PackageBannerMobileComponent from '../PackageBannerMobileComponent/PackageBannerMobileComponent';
import { getAppEnv } from '../../../config/env';
import { Context } from '../../AppContext';
import { isMobile } from '../../utils/commonUtils';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

interface PackageBannerProps {
  packageData: any;
}

const PackageBanner = React.memo(({ packageData }: PackageBannerProps) => {
  const { trackTemplateEvent } = useContext(Context);
  useEffect(() => {
    if (isMobile()) {
      setTimeout(() => {
        trackTemplateEvent(`Cab_SEO_Packages_Mobile_Banner_Shown`);
      }, 2000);
    } else {
      setTimeout(() => {
        trackTemplateEvent(`Cab_SEO_Packages_Desktop_Banner_Shown`);
      }, 2000);
    }
  }, []);
  return (
    <div className="packageDataContainer" style={{ height: '100px' }}>
      <div className="mobileShow">
        <PackageBannerMobileComponent packageData={packageData} />
      </div>
      <img
        height={100}
        src={`${PUBLIC_URL}/static/public/${packageData.dweb_banner.image}`}
        alt="Package Banner"
        onClick={() => {
          window.location.href = packageData.dweb_banner.redirection_url;
          trackTemplateEvent(`Cab_SEO_Packages_Desktop_Banner_Clicked`);
        }}
        className={'banner desktopShow cursorPointer'}
      />
    </div>
  );
});

export default PackageBanner;
